import { FormControl, InputLabel, OutlinedInput } from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';
import { PatternFormat } from 'react-number-format';
import { useSelector } from 'react-redux';
import IntlMessages from 'Util/IntlMessages';
import check1 from 'Assets/img/sign/ic_check_blue_16.png';
import check2 from 'Assets/img/sign/ic_check_blue_16@2x.png';
import check3 from 'Assets/img/sign/ic_check_blue_16@3x.png';
import { getImageSet } from 'Util/DataUtils';

const check = getImageSet([check1, check2, check3]);

const VerifiedPhoneInput = ({ value }) => {
  const { formatMessage } = useIntl();
  const { country } = useSelector(state => state.settings);

  return (
    <FormControl
      fullWidth
      variant="outlined"
      sx={{
        '& label': {
          color: '#000',
          fontFamily: 'Pretendard',
        },
        '& label.Mui-focused': {
          color: '#000',
        },

        '& .MuiOutlinedInput-root': {
          fieldset: {
            borderRadius: '10px',
            border: '1px solid #ddd',
            backgroundColor: '#f5f6f8',
            zIndex: 0,
          },
        },
      }}
    >
      <InputLabel htmlFor={'consult.customer.create.phone'}>{formatMessage({ id: 'consult.customer.create.phone' })}</InputLabel>
      <PatternFormat
        id="consult.customer.create.phone"
        value={value}
        format={country === 'ko' ? '###-####-####' : '##########'}
        type={'text'}
        placeholder={formatMessage({ id: 'consult.customer.create.phone' })}
        label={formatMessage({ id: 'consult.customer.create.phone' })}
        customInput={OutlinedInput}
        disabled
        inputProps={{
          style: {
            color: '#666',
            fontFamily: 'Pretendard',
            fontSize: '15px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: 'normal',
            padding: '15px',
            zIndex: 1,
          },
        }}
        endAdornment={
          <div style={{ color: '#0567f9', fontSize: '13px', fontWeight: 400, lineHeight: 'normal', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: '2px', zIndex: 1 }}>
            <IntlMessages id="signIn.join.phone.verify.complete.word" />
            <img {...check} alt="check" />
          </div>
        }
      />
    </FormControl>
  );
};

export default VerifiedPhoneInput;
